// extracted by mini-css-extract-plugin
module.exports = {"root":"Breadcrumb_root__yyO4a","arrow":"Breadcrumb_arrow__z4j3z"};